<template>
  <div class="news-wrap container">
    <!-- 24.5.17 最新动态 dxm -->
    <el-row type="flex" justify="space-between" style="align-items: end">
      <el-col :span="9">
        <h2 class="h2-title">{{ $t("home.latestNews") }}</h2>
      </el-col>
      <el-col :span="6">
        <div class="more" @click="tapnewsList">
          {{ $t("home.newsMore")
          }}<img class="more-icon" src="../../../assets/more_icon.png" alt="" />
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="news-top" @click="tapnewsDetail(articleList[0])">
          <div class="news-left">
            <div class="news-title">
              {{ articleList[0] && articleList[0].title }}
              <!-- {{
                langSet == "cn"
                  ? "重温觉醒年代 感受工人力量"
                  : "Relive the awakening and feel the power of the workers"
              }} -->
            </div>
            <div class="line"></div>
            <!-- <div class="news-content">
              {{ articleList[0] && articleList[0].title }}
            </div> -->
            <div class="news-time">
              {{ articleList[0] && articleList[0].create_time }}
            </div>
          </div>
          <img
            class="news-img"
            :src="articleList[0] && $imgUrl+articleList[0].image"
            alt=""
          />
        </div>

        <div class="news-list">
          <div
            class="news-item"
            v-for="(item, index) in newArticleList"
            :key="index"
            @click="tapnewsDetail(item)"
          >
            <img class="news-img" :src="item && $imgUrl+item.image" alt="" />
            <div class="news-title">{{ item && item.title }}</div>
            <div class="news-time">{{ item && item.create_time }}</div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  props: {
    articleList: Array,
    newArticleList: Array,
  },
  data() {
    return {
      langSet: "",
    };
  },
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
  },
  methods: {
    // zhang 跳转新闻详情
    tapnewsDetail(item) {
      this.$router.push({
        name: "newsDetail",
        query: {
          id: item.id,
        },
      });
    },
    //zhang 查看更多 跳转新闻列表
    tapnewsList() {
      this.$router.push({
        name: "newsList",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.news-wrap {
  padding-top: 78px;
  padding-bottom: 130px;
  .more {
    font-size: 14px;
    color: #757575;
    cursor: pointer;
    text-align: right;
    line-height: 28px;
    &:hover{
      color: #233889;
    }
    .more-icon {
      // margin-bottom: -2px;
      width: 16px;
      margin-left: 14px;
    }
  }
  .news-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    cursor: pointer;
    .news-left {
      font-size: 36px;
      color: #2c2c2e;
      line-height: 62px;
      margin-right: 40px;
      &:hover {
        color: #233889;
      }
      .news-title {
        color: #233889;
      }
      .line {
        width: 95px;
        height: 4px;
        margin: 20px 0;
        background: #3a3a3c;
      }
      .news-time {
        font-weight: 400;
        font-size: 14px;
        color: #3a3a3c;
        line-height: 22px;
        margin-top: 40px;
      }
    }
    .news-img {
      width: 640px;
      // height: 360px;
    }
  }
  .news-list {
    display: flex;
    margin-top: 25px;
    .news-item {
      width: 304px;
      font-size: 14px;
      color: #3a3a3c;
      line-height: 22px;
      margin-right: 25px;
      cursor: pointer;
      &:hover .news-title {
        color: #233889;
      }
      &:last-child {
        margin-right: 0;
      }
      .news-img {
        width: 100%;
        height: 185px;
        cursor: pointer;
        margin-bottom: 15px;
      }
      .news-title {
        font-weight: 500;
        font-size: 16px;
        color: #2c2c2e;
        line-height: 22px;
        margin-bottom: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
}
@media only screen and (max-width: 1280px) {
  .news-wrap {
    .news-top {
      .news-left {
        font-size: 30px;
        line-height: 50px;
        .news-time {
          margin-top: 20px;
        }
      }
      .news-img {
        width: 40%;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .news-wrap {
    padding-top: 10px;
    padding-bottom: 0.5rem;
    .more {
      font-size: 13px;
      line-height: 28px;
      .more-icon {
        width: 12px;
        // margin-left: 5px;
      }
    }
    .news-top {
      flex-wrap: wrap;
      .news-left {
        font-size: 20px;
        line-height: 30px;
        .line {
          margin: 10px 0;
        }
        .news-time {
          margin-top: 10px;
        }
      }
      .news-img {
        width: 100%;
        margin-top: 10px;
      }
    }
    .news-list {
      flex-wrap: wrap;
      .news-item {
        width: 100%;
        font-size: 14px;
        margin-right: 0;
        margin-bottom: 20px;
        .news-img {
          height: auto;
          margin-bottom: 10px;
        }
        .news-title {
          font-size: 18px;
          line-height: 28px;
          margin-bottom: 5px;
        }
      }
    }
  }
}
</style>